// extracted by mini-css-extract-plugin
export default {"container":"GoTopButton-module__container--jyIQp","button":"GoTopButton-module__button--BDt5D"};